/**
 * @generated SignedSource<<cffb7f38d44f446b735d4a50989217c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActionButtonsRoadmap_collection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapMenuItems_collection">;
  readonly " $fragmentType": "ActionButtonsRoadmap_collection";
};
export type ActionButtonsRoadmap_collection$key = {
  readonly " $data"?: ActionButtonsRoadmap_collection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionButtonsRoadmap_collection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ActionButtonsRoadmap_collection",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RoadmapMenuItems_collection"
    }
  ],
  "type": "JiraProductDiscoveryCollection"
};

(node as any).hash = "93db3b7ead7139642a9e3f1c77472ba9";

export default node;
